import { PureComponent } from 'react';

import DropDownButton from './DropDownButton';

import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';

import { faLineHeight } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class AlignmentControls extends PureComponent {
  render() {
    const { blockData, onUpdateBlockData } = this.props;
    const currentSpacing = blockData?.get('lineSpacing');
    const margins = {
      marginTop: blockData?.get('marginTop'),
      marginBottom: blockData?.get('marginBottom'),
    };
    return (
      <DropDownButton
        icon={
          <>
            <FontAwesomeIcon fixedWidth icon={faLineHeight} />
            <FontAwesomeIcon fixedWidth icon={faCaretDown} size="xs" />
          </>
        }
        menu
        ToolbarButtonProps={{ active: !!currentSpacing }}
        tooltip="line spacing"
      >
        {[1, undefined, 1.5, 2, 3].map((spacing, i) => (
          <MenuItem
            key={i}
            onMouseDown={() => onUpdateBlockData({ lineSpacing: spacing })}
            selected={currentSpacing === spacing}
          >
            {spacing ? `${spacing}x` : 'Normal'} line spacing
          </MenuItem>
        ))}
        {[
          ['marginTop', 'before'],
          ['marginBottom', 'after'],
        ].flatMap(([side, sideLabel]) => [
          <Divider key={`${side}-divider`} />,
          ...[
            ['sm', 'small'],
            ['md', 'medium'],
            ['lg', 'large'],
          ].map(([size, sizeLabel]) => (
            <MenuItem
              key={`${side}-${size}`}
              onMouseDown={() => onUpdateBlockData({ [side]: margins[side] === size ? undefined : size })}
              selected={margins[side] === size}
            >
              {`Add ${sizeLabel} space ${sideLabel}`}
            </MenuItem>
          )),
        ])}
      </DropDownButton>
    );
  }
}
